/**
 * localStorage keys for the external portal session.
 *
 * Single source of truth, imported by the external auth context, the external
 * axios instance, and the SSO callback page so the key strings never drift.
 */
export const EXTERNAL_TOKEN_KEY = 'external_access_token';
export const EXTERNAL_REFRESH_TOKEN_KEY = 'external_refresh_token';
export const EXTERNAL_TENANT_SLUG_KEY = 'external_tenant_slug';
